namespace('compass.account');

compass.account.EditAccountWidget = compass.defineWidget(function EditAccountWidget(options) {
	var me = this;
	var _settings = options;
	var _account = _settings.account;
	var d = jQuery.dom.getContext(me);
	var officeName = options.account.officeName;
	var _validator = new compass.validator({
		widget: me,
		onValid: function (field, opts) {
			field.removeClass("invalid");
		},
		onInvalid: function (field, opts) {
			field.addClass("invalid");
		}
	});

	var _labels = {
		contact: "Name",
		email: "Email Address",
		phone: "Phone Number"
	};

	me.getValues = function () {
		return {
			"email": _inputs.email.val() === _account.email ? "" : _inputs.email.val(),
			"phone": _inputs.phone.val() === _account.phone ? "" : _inputs.phone.val()
		};
	};

	me.render = function (widgetElem) {
		_inputs = {
			email : d.input({
				type: "email",
				autocomplete: 'off',
				id: "email-input",
				className: 'email-autocomplete'
			}).val(_account.email),
			phone : d.input({
				type: "text",
				autocomplete: 'off'
			}).val(_account.phone)
		};

		_validator.addFields(_inputs.email, _validator.EMAIL);
		_validator.addFields(_inputs.phone, _validator.PHONE);

		widgetElem.append(d.h2({
				className: "headerTitle"
			}, "Your "+officeName+" Account"),
			d.div({
				className: "contactLabel"
			}, _labels.contact),
			d.div({
				className: "contact"
			}, _account.name),
			d.label({
			}, _labels.email),
			_inputs.email,
			d.label({
			}, _labels.phone),
			_inputs.phone,
			d.button({
				className: "button"
			}, "Update").activate(function () {
				_validation_res = _validator.validate();
				if (_validation_res.length === 0) {
					me.trigger(CompassEvents.UpdateAccountInfo, me.getValues());
				}
				else {
					for(var _i = 0; i < _validation_res.length; i++) {
						if(!$(_validation_res[_i]).hasClass("invalid")) {
							$(_validation_res[_i]).addClass("invalid");
						}
					}
				}
			})
		);

		const intervalId = setInterval(() => {
			const inputElement = document.querySelector("#email-input");
			if (inputElement) {
				me.find("#email-input").emailautocomplete({
					suggClass: "eac-sugg",
					domains: ["aol.com", "att.net", "bellsouth.net", "comcast.com", "comcast.net", "gmail.com", "hotmail.com", "icloud.com", "live.com", "me.com", "msn.com", "outlook.com", "qq.com", "sbcglobal.net", "yahoo.com", "ymail.com"]
				});
				clearInterval(intervalId);
			}
		}, 100);
	};
}, {
	WUID: "crap",
	widgetName: 'EditAccountWidget',
	account: {}
});
